import { useSearchParams } from '@/routing';
import { useEffect } from 'react';
import type { UseSearchFieldStatesReturn } from './useSearchFieldStates';
import { buildSoChiTietCongNoSearchPayload } from '../utils';
import type { SearchFormValues } from '../schema';

interface UseLoadFromLocalStorageParams {
  searchFieldStates: UseSearchFieldStatesReturn;
  setSearchParams: (params: SearchFormValues) => void;
  setQueryParams: (params: SearchFormValues) => void;
  setShowTable: (show: boolean) => void;
  handleInitialSearchClose: () => void;
}

export function useLoadFromLocalStorage({
  searchFieldStates,
  setSearchParams,
  setQueryParams,
  setShowTable,
  handleInitialSearchClose
}: UseLoadFromLocalStorageParams) {
  const searchParamsFromUrl = useSearchParams();

  useEffect(() => {
    const customerCodeFromUrl = searchParamsFromUrl.get('ma_kh');
    if (!customerCodeFromUrl) return;

    const savedPayload = localStorage.getItem('bang-can-doi-phat-sinh-cong-no-payload');
    if (!savedPayload) return;

    try {
      const { kh_data, tk_data, ...parsedPayload } = JSON.parse(savedPayload);
      searchFieldStates.setCustomer(kh_data);
      searchFieldStates.setAccount(tk_data);
      const formatDate = (dateStr?: string) =>
        dateStr && dateStr.length === 8 && !dateStr.includes('-')
          ? `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`
          : dateStr || '';

      const mergedParams: SearchFormValues = {
        ngay_ct1: formatDate(parsedPayload.ngay_ct1),
        ngay_ct2: formatDate(parsedPayload.ngay_ct2),
        tk: tk_data?.uuid || '',
        ma_kh: searchParamsFromUrl.get('ma_kh') || '',
        ct_vt: !!parsedPayload.ct_vt,
        so_du: !!parsedPayload.so_du,
        groupBy: Array.isArray(parsedPayload.group_by)
          ? parsedPayload.group_by
          : parsedPayload.group_by
            ? [parsedPayload.group_by]
            : [],
        mau_bc: parsedPayload.mau_bc ?? 20,
        data_analysis_struct: parsedPayload.data_analysis_struct || '',
        nguoi_lap: parsedPayload.nguoi_lap || ''
      };

      const finalPayload = buildSoChiTietCongNoSearchPayload(
        mergedParams,
        tk_data?.uuid || '',
        searchParamsFromUrl.get('ma_kh') || ''
      );
      setSearchParams(finalPayload);
      setQueryParams(finalPayload);
      setShowTable(true);
      handleInitialSearchClose();
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
